// src/pages/ReportIssue/components/SuccessMessage.js
import React from "react";
import {
    Typography,
    Box,
    Button as MuiButton
} from "@mui/material";
import { CheckCircle } from "react-feather";

const SuccessMessage = ({ navigate }) => {
    // Default navigation function if none provided
    const handleNavigation = () => {
        if (navigate && typeof navigate === 'function') {
            navigate('/tickets');
        } else {
            console.warn("Navigation function not provided to SuccessMessage");
            // Fallback to window.location if navigate isn't available
            window.location.href = '/tickets';
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: 4
            }}
        >
            <Box
                sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    backgroundColor: '#D1FAE5',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 3
                }}
            >
                <CheckCircle size={48} color="#059669" />
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                Issue Reported Successfully!
            </Typography>

            <Typography variant="body1" color="textSecondary" sx={{ mb: 3, textAlign: 'center', maxWidth: 600 }}>
                Your issue has been submitted and our team will review it shortly.
                You will be redirected to the tickets page in a few seconds.
            </Typography>

            <MuiButton
                variant="contained"
                onClick={handleNavigation}
                sx={{
                    mt: 2,
                    borderRadius: '8px',
                    backgroundColor: '#398DD2',
                    textTransform: 'none',
                    boxShadow: 'none',
                    px: 3,
                    '&:hover': {
                        backgroundColor: '#2b78be',
                        boxShadow: 'none'
                    }
                }}
            >
                View My Issues
            </MuiButton>
        </Box>
    );
};

// Default props
SuccessMessage.defaultProps = {
    navigate: () => {
        console.warn("Default navigation used in SuccessMessage");
        window.location.href = '/tickets';
    }
};

export default SuccessMessage;